/*!
 * axios (https://github.com/axios/axios)
 * Copyright (c) 2014-present Matt Zabriskie
 * MIT License (https://github.com/soldair/node-qrcode/blob/master/license)
*/
import axios from 'axios'
import store from '@/store/'

const _axios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT
})

// リクエスト時の共通処理
_axios.interceptors.request.use(config => {
  // トークンが存在する場合はAuthorizationヘッダに付加
  if (store.state.Auth.token) {
    config.headers.Authorization = `Bearer ${store.state.Auth.token}`
  }
  console.info(`--> ${config.method} ${config.url}`
            + ` auth[${config.headers.Authorization}]`
            + ` body[${config.data? JSON.stringify(config.data) : ''}]` )
  return config
})

// レスポンス時の共通処理
_axios.interceptors.response.use(
  // 正常処理 トークンとお知らせの更新
  response => {
    console.info(`<-- ${response.config.method} ${response.config.url} ${response.status} ${JSON.stringify(response.data)}`)
    if(response.headers["content-type"]
     && response.headers["content-type"].indexOf('application/json') > -1){
      store.commit('Auth/saveToken', response.data.jwt)
      store.commit('Message/saveInfo', response.data.information)
    }
    store.commit('Message/saveError', [])
    return response
  },
  // 異常処理 トークン,メッセージ情報更新
  error => {
    console.error(`<-- ${error.config.method} ${error.config.url} ${error.response ?
      `${error.response.status} ${JSON.stringify(error.response.data)}`: `${error}`}`)
    if(error.response.headers["content-type"]
     && error.response.headers["content-type"].indexOf('application/json') > -1){
      store.commit('Auth/saveToken', error.response.data ? error.response.data.jwt : undefined)
      store.commit('Message/saveInfo', error.response.data ? error.response.data.information : [])
    }
    return Promise.reject(error)
  })
export default _axios